/**
 * ContactController.java 对应的 model
 */

import Model from './model'
const model = new Model()

class Contact {

    /**
     * 获取联系人
     * @param params
     * @returns {*}
     */
    static getContacts(params) {
        return model.post('contact/getEmployerContacts', params)
    }

    /**
     * 获取标签
     * @returns {*}
     */
    static getContactTags() {
        return model.post('contact/getEmployerTags')
    }

}
export default Contact



// WEBPACK FOOTER //
// ./bootsets/models/contact.js